import React, { useState } from 'react'
import Navbar from '../../components/Navbar/Navbar'
import { Button, Form, Input, Modal, Table, Row, Col, TimePicker } from 'antd'
import { DeleteOutlined, EditOutlined, ExclamationCircleOutlined } from '@ant-design/icons'
import { usePostRequest } from '../../hooks/usePostRequest'
import { UseGetRequest } from '../../utils/api/ApiRequests'
import moment from 'moment'
import dayjs from 'dayjs'


const AddSubmitButton = ({ form, isLoading }) => {
  const [submittable, setSubmittable] = useState(false);
  
  // Watch all values
  const values = Form.useWatch([], form);
    React.useEffect(() => {
      form.validateFields({
        validateOnly: true,
      }).then(() => {
        setSubmittable(true);
      },
      () => {
        setSubmittable(false);
      },
      );
    }, [values]);
    return (
    <Button type="primary" htmlType="submit" disabled={!submittable} loading={isLoading}>Submit</Button>
    );
};


export default function Project() {
  const [form] = Form.useForm();
  const {callPost, isLoading} = usePostRequest(()=>{
    setShowAddModal(false); 
    setShowEditModal(false);
    setShowViewModal(false);
    form.resetFields();
    setFilterConfig((prev) => ({...prev, is_updated: !prev.is_updated}))});
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [showViewModal, setShowViewModal] = useState(false);
  const [clickedRowData, setClickedRowData] = useState({});
  // const [initialValues, setInitialValues] = useState({});
  const [tableData, setTableData] = useState([]);
  const [modal, contextHolder] = Modal.useModal();
  const [filterConfig, setFilterConfig] = useState({
    is_updated: false
  });
  const [isFetching, setIsFetching] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  
  const tableColumns = [
    {
      title: 'Code',
      dataIndex: 'id',
      key: 'id',
  },
    {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        width: '30%',
    },
    {
      title: 'Shift',
      dataIndex: 'shift',
      key: 'shift',
      render: (data, record) => (
        <>
          <Row className='d-flex justify-content-between w-50'><Col>{moment(record.first_timein, 'h:mm A').format('hh:mm A')}</Col><Col>{moment(record.first_timeout, 'h:mm A').format('hh:mm A')}</Col></Row>
          <Row className='d-flex justify-content-between w-50'><Col>{record.second_timein?moment(record.second_timein, 'h:mm A').format('hh:mm A'):null}</Col><Col>{record.second_timeout?moment(record.second_timeout, 'h:mm A').format('hh:mm A'):null}</Col></Row>
        </>
      )
    }
  ];

  const confirmDelete = (project) => {
    modal.confirm({
      title: `Are you sure you want to delete project "${project.name}"?`,
      icon: <ExclamationCircleOutlined />,
      content: 'You cannot undo this action.',
      okText: 'Delete',
      cancelText: 'Cancel',
      onOk: ()=>handleDelete(project.id),
      okType: 'danger',
    });
  };

  const onFinish = (formInputs) => {
    
    const finalValues = {
      name: formInputs.name,
      first_timein: formInputs.first_timein.format('HH:mm'),
      first_timeout: formInputs.first_timeout.format('HH:mm'),
      second_timein: formInputs.second_timein?formInputs.second_timein.format('HH:mm'):null,
      second_timeout: formInputs.second_timeout?formInputs.second_timeout.format('HH:mm'):null,
    }
    callPost(
      "projects/add", 
      finalValues,
      false
    );
  };

  const onEdit = (formInputs) => {
    const finalValues = {
      name: formInputs.name,
      first_timein: formInputs.first_timein.format('HH:mm'),
      first_timeout: formInputs.first_timeout.format('HH:mm'),
      second_timein: formInputs.second_timein?formInputs.second_timein.format('HH:mm'):null,
      second_timeout: formInputs.second_timeout?formInputs.second_timeout.format('HH:mm'):null,
    }
    callPost(
      `projects/update/${clickedRowData.id}`, 
      finalValues,
      false
    );
  };

  const handleSearch = (e) => {
    if (e.key==="Enter") {
      setFilterConfig((prev) => ({...prev, term: searchTerm}));
    }
  }

  function handleDelete(passedId) {
    callPost("projects/delete/" + passedId,  {}, false);
  }

  const handleRowClick = (rowData) => {
    setClickedRowData(rowData);
    const formattedValues = {...rowData}
    formattedValues.first_timein = moment(rowData.first_timein,"hh:mm A");
    formattedValues.first_timeout = moment(rowData.first_timeout,"hh:mm A");
    formattedValues.second_timein = rowData.second_timein?moment(rowData.second_timein,"hh:mm A"):null;
    formattedValues.second_timeout = rowData.second_timeout?moment(rowData.second_timeout,"hh:mm A"):null;
    form.setFieldsValue(formattedValues); 
    setShowViewModal(true);
  };

  const rowProps = (record) => ({
    onClick: () => handleRowClick(record),
  });

    // React.useEffect(() => {
  //   const searchTimeout = setTimeout(() => {
  //     setFilterConfig((prev) => ({ ...prev, term: searchTerm }));
  //   }, 2000);

  //   return () => {
  //     clearTimeout(searchTimeout);
  //   };
  // }, [searchTerm]);

React.useEffect(() => {
  async function fetchTableData  () {
    setIsFetching(true);
    setTableData([]);
    const response = await UseGetRequest("projects/get", filterConfig);
    if (response.data) {
        setTableData(response.data.data);
    }
    setIsFetching(false);
  }

    fetchTableData ();
}, [filterConfig]);


  return (
    <Navbar
    activeNav="project"
      pageTitle="Store"
      pageButtonTitle="Add Store"
      setSearchQuery={(e) => setSearchTerm(e)}
      onSearch={handleSearch}
      searchPlaceholder="store"
      onClickButton={() => setShowAddModal(true)}
      isManager
      searchable
    >
      <Table
        className="mt-5"
        rowKey="id"
        onRow={(record) => ({
          ...rowProps(record),
          style: { cursor: "pointer" },
        })}
        columns={tableColumns}
        dataSource={tableData}
        loading={isFetching || isLoading}
      />

      <Modal
      maskClosable={false}
        title={`${showAddModal ? "Add" : "Edit"} Store`}
        centered
        open={showAddModal || showEditModal}
        footer={null}
        onCancel={() => {
          setShowAddModal(false);
          setShowEditModal(false);
          form.resetFields();
        }}
      >
        <Form
          className="mt-3 mx-3"
          form={form}
          name="validateOnly"
          layout="vertical"
          onFinish={showAddModal ? onFinish : onEdit}
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[
              {
                required: true, whitespace: true,
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Row>
            <Col xs={24}>SHIFT</Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Time In 1"
                name="first_timein"
                rules={[
                  {
                    required: true
                  },
                ]}
              >
                <TimePicker format={"hh:mm A"} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Time Out 1"
                name="first_timeout"
                rules={[
                  {
                    required: true
                  },
                ]}
              >
                <TimePicker format={"hh:mm A"} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Time In 2"
                name="second_timein"
              >
                <TimePicker format={"hh:mm A"} />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Time Out 2"
                name="second_timeout"
              >
                <TimePicker format={"hh:mm A"} />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Row className="d-flex justify-content-end">
              <Row>
                <Button
                  className="me-2"
                  danger
                  onClick={() => {
                    setShowAddModal(false);
                    setShowEditModal(false);
                  }}
                  disabled={isLoading}
                >
                  Cancel
                </Button>
                <AddSubmitButton form={form} isLoading={isLoading} />
              </Row>
            </Row>
          </Form.Item>
        </Form>
      </Modal>

      <Modal
        title="Review Store"
        centered
        open={showViewModal}
        footer={null}
        onCancel={() => {
          setShowViewModal(false);
          form.resetFields();
        }}
      >
        <Form
          className="mt-3 mx-3"
          form={form}
          name="editForm"
          layout="vertical"
        >
          <Form.Item
            name="name"
            label="Name"
            rules={[
              {
                required: true, whitespace: true,
              },
            ]}
          >
            <Input disabled />
          </Form.Item>

          <Row>Shift</Row>
          <Row>
            <Col xs={24} md={12}>
              <Form.Item
                label="Time In 1"
                name="first_timein"
              >
                <TimePicker format={"hh:mm A"} disabled/>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Time Out 1"
                name="first_timeout"
              >
                <TimePicker format={"hh:mm A"} disabled/>
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Time In 2"
                name="second_timein"
              >
                <TimePicker format={"hh:mm A"} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} md={12}>
              <Form.Item
                label="Time Out 2"
                name="second_timeout"
              >
                <TimePicker format={"hh:mm A"} disabled />
              </Form.Item>
            </Col>
          </Row>

          <Form.Item>
            <Row className="d-flex justify-content-end">
              <Button
                danger
                onClick={() => setShowViewModal(false)}
                disabled={isLoading}
              >
                Cancel
              </Button>
              <Button
                type="text"
                onClick={() => {
                  setShowViewModal(false);
                  setShowEditModal(true);
                }}
                icon={<EditOutlined />}
              >
                Edit
              </Button>
              <Button
                type="text"
                danger
                onClick={() => {
                  confirmDelete(clickedRowData);
                }}
                icon={<DeleteOutlined />}
              >
                Delete
              </Button>
            </Row>
          </Form.Item>
        </Form>
      </Modal>
      {contextHolder}
    </Navbar>
  );
}